/*
 * sq-classToggler v0.0.1
 * Author: adewezlopez@squiz.net
 * A css class toggling service to control them all!

 * This plugin is designed to toggle classes on elements
 * Basically, you have a master element and slave element(s),
 * when clicking on the master element, classes of your choosing
 * are toggled on both the master and slave(s).

 * The purpose is to be able to change styles on elements with a click, touch or key press (except for tab),
 * but keeping the styles themselves controlled by CSS.

 * There are various settings which handle to toggling differently:
 * settings.slaves              // selector of all slaves elements
 * settings.masters_active      // the class name to toggle for the masters
 * settings.slaves_active       // the class name to toggle for the slaves
 * settings.grouped [false]     // if true, click a master will remove the toggle classes for all other masters & slaves
 * settings.touch [false]       // if true, responds to touch events only
 * settings.outside [false]     // if true, clicking outside the slave removes toggle classes
 * settings.autoinit [false]    // if true, the first set of masters and slaves will toggled
 * settings.neveroff [false]    // if true, a master can never toggle itself and it's slave off.
 * settings.doubleclick [false] // if true, a click on an active master will have default click behaviour - good for mobile accordion nav

** Fixes - add enter/spacebar option

 */


 $.fn.extend({

  sqClassToggler: function(settings) {

    var self = this;

    var defaults = {
      "slaves"          : ".sq-toggle-slave",
      "masters_active"  : "sq-active",
      "slaves_active"   : "sq-active",
      "grouped"         : false,
      "touch"           : false,
      "outside"         : false,
      "autoinit"        : false,
      "neveroff"        : false,
      "doubleclick"     : false
    }

    var settings = $.extend(defaults, settings);

    var masters = $(self)
    ,   slaves  = $(settings.slaves);

    if (settings.autoinit) {
      masters.eq(0).toggleClass(settings.masters_active);
      slaves.eq(0).toggleClass(settings.slaves_active);
    }

    return self.each(function(i) {
      // the triggered function on click of master
      var classToggler = function(e) {
        if (settings.doubleclick && $(this).hasClass(settings.masters_active)) {
           return;
        } else {
          e.stopPropagation();
          e.preventDefault();
        }

        // Set current triggered master and its slave.
        var master = $(this)
        ,   slave  = slaves.eq(i);

        // Default behaviour - Toggle the clicked master and its slave
        master.toggleClass(settings.masters_active);
        slave.toggleClass(settings.slaves_active);

        if (settings.neveroff && !master.hasClass(settings.masters_active)) {
          master.addClass(settings.masters_active);
          slave.addClass(settings.slaves_active);
        }

        // Remove other instances of active classes if settings.grouped is true
        if (settings.grouped) {
          masters.not(master).removeClass(settings.masters_active);
          slaves.not(slave).removeClass(settings.slaves_active);
        }
      }
      // Events that trigger the classToggler
      if (!Modernizr.touch && settings.touch) {
        return;
      } else {
        $(this).on("click", classToggler);
      }

      // remove toggle classes on outside click of slave
      if (settings.outside) {
        $(document).on("click", function(e) {
          var els = $(self).add(settings.slaves);
          if (!els.is(e.target) && els.has(e.target).length === 0)  {
            masters.removeClass(settings.masters_active);
            slaves.removeClass(settings.slaves_active);
          }
        });
      }
    });
  }
});